var _rect, _g, _rect2, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOutward(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    rx: 5,
    fill: "#395CD6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.1875 4.99998H7.34375C6.05141 4.99998 5 6.05139 5 7.34373V10.1875C5 11.4798 6.05141 12.5312 7.34375 12.5312H10.1875C11.4798 12.5312 12.5312 11.4798 12.5312 10.1875V7.34373C12.5312 6.05139 11.4798 4.99998 10.1875 4.99998Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6562 13.4687H15.8125C14.5202 13.4687 13.4688 14.5201 13.4688 15.8125V18.6562C13.4688 19.9486 14.5202 21 15.8125 21H18.6562C19.9486 21 21 19.9486 21 18.6562V15.8125C21 14.5201 19.9486 13.4687 18.6562 13.4687Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6562 4.99998H15.8125C14.5202 4.99998 13.4688 6.05139 13.4688 7.34373V10.1875C13.4688 11.9968 11.9968 13.4687 10.1875 13.4687H7.34375C6.05141 13.4687 5 14.5201 5 15.8125V18.6562C5 19.9486 6.05141 21 7.34375 21H10.1875C11.4798 21 12.5312 19.9486 12.5312 18.6562V15.8125C12.5312 14.0032 14.0032 12.5312 15.8125 12.5312H18.6562C19.9486 12.5312 21 11.4798 21 10.1875V7.34373C21 6.05139 19.9486 4.99998 18.6562 4.99998Z",
    fill: "white"
  })))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    rx: 5,
    fill: "#395CD6"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.0005 11.1742C14.8866 11.1742 16.421 9.63984 16.421 7.75377C16.421 5.86771 14.8866 4.33333 13.0005 4.33333C11.1145 4.33333 9.58008 5.86771 9.58008 7.75377C9.58008 9.63984 11.1145 11.1742 13.0005 11.1742Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.59 12.8318C17.5885 12.8314 17.5857 12.8303 17.5843 12.83C17.1389 12.7212 15.7751 12.5304 15.7751 12.5304C15.6212 12.483 15.4567 12.5645 15.4013 12.7164L13.3485 18.3488C13.2301 18.6737 12.7705 18.6737 12.6521 18.3488L10.5993 12.7164C10.5546 12.5938 10.4388 12.5168 10.3147 12.5168C10.2853 12.5168 8.88306 12.7135 8.41623 12.8295C7.14057 13.1467 6.33594 14.4012 6.33594 15.7085V20.395C6.33594 21.0973 6.90531 21.6667 7.60763 21.6667H18.3918C19.0941 21.6667 19.6635 21.0973 19.6635 20.395V15.6929C19.6634 14.3912 18.8273 13.2361 17.59 12.8318Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.774 12.423C13.6921 12.3337 13.5723 12.2888 13.4511 12.2888H12.5474C12.4263 12.2888 12.3064 12.3337 12.2246 12.423C12.0977 12.5612 12.0793 12.7608 12.1693 12.9168L12.6525 13.6451L12.4263 15.5529L12.8717 16.7377C12.9151 16.8568 13.0836 16.8568 13.127 16.7377L13.5724 15.5529L13.3462 13.6451L13.8293 12.9168C13.9193 12.7608 13.9008 12.5612 13.774 12.423Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.3333,
    height: 17.3333,
    fill: "white",
    transform: "translate(4.33301 4.33333)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(5 4.99998)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.3333,
    height: 17.3333,
    fill: "white",
    transform: "translate(4.33301 4.33333)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.3333,
    height: 17.3333,
    fill: "white",
    transform: "translate(4.33301 4.33333)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutward);
export default __webpack_public_path__ + "static/media/outward.37460fc24395846e0d373871f49b1a7c.svg";
export { ForwardRef as ReactComponent };